let PrivacyCluster = {
	U1: "U1",
	U2: "U2",
	U3: "U3",
	U4: "U4",
	U5: "U5"
};

export default PrivacyCluster;